import { SB } from '@play-co/replicant';

/**
 * Daily Fortune Share state schema
 */
export const dailyFortuneShareSchema = {
  dailyFortuneShare: SB.object({
    // Total number of times the user has viewed fortunes (all-time count)
    alltimeViewCount: SB.int().default(0).min(0),
    // Timestamp of the last daily fortune played
    dailyTimestamp: SB.int().optional(),
    // Timestamp of the last time the pet was unhealthy for daily fortune
    unhealthyTimestamp: SB.int().optional(),
  }).optional(),
};
